import { useNavigate } from '@reach/router';
import type React from 'react';

import { addTrackingParamsToURL } from '../../utils/tracking';

type HandleTrackingParams = {
  trackingAttributes?: Record<string, string>;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
  href?: string;
  target?: string;
};

export const useTracking = () => {
  const navigate = useNavigate();

  const generateHandleTracking =
    ({ onClick, to, href, target, trackingAttributes }: HandleTrackingParams) =>
    (e: React.MouseEvent) => {
      e.preventDefault();

      const trackingUrl = addTrackingParamsToURL({
        url: to || href,
        params: trackingAttributes,
      });

      if (onClick) {
        onClick(e as React.MouseEvent);
      }

      if (target) {
        window.open(trackingUrl, target);
      } else {
        const handleOpen = to ? navigate : window.open;
        handleOpen(trackingUrl);
      }
    };

  return {
    generateHandleTracking,
  };
};
